import styled, { css } from 'styled-components'
import Tooltip from '../Tooltip'

interface ContainerProps {
  isFocused: boolean
  isFilled: boolean
  isErrored: boolean
  hasSufix?: boolean
  isDisabled?: boolean
  color?: 'white' | 'gray'
}

const colorVariation = {
  white: css`
    background-color: #FFF;
    border: 2px solid #F4F6F5;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
    &:hover {
      border: 2px solid ${props => props.theme.colors.mainColor};
  }
  `,
  gray: css`
    background-color: #F4F6F5;
    border: 2px solid #F4F6F5;
    box-shadow: none;
    &:hover {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
    }
    `,
  disabled: css`
    background-color: #FFF;
    border: #FFF;
    box-shadow: none;
  `,
}


export const Container = styled.div<ContainerProps>`
  width: 100%;
  ${props => !props.isDisabled ? colorVariation[props.color || 'white'] : colorVariation['disabled']  };
  text-align: center;
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 4px;
  transition: 0.2s;

  ${props =>
    props.isErrored &&
    css`
      border-color: ${props => props.theme.colors.dange};
    `}

  > label {
    font-weight: 600;
    color: ${ props => props.theme.colors.greyDarker};
    padding-bottom: 4px;
  }

  > small {
    color: ${props => props.theme.colors.grey04};
    font-size: 12px;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 35px;

    input {
      color: ${props => props.theme.colors.mainColor};
      font-size: 24px;
      font-weight: 600;
      border: none;
      flex: 1;
      text-align: ${props => (props.hasSufix ? 'right' : 'center')};
      width: ${props => (props.hasSufix ? '50%' : 'max-content')};
      padding: 0 8px;
      background: inherit;

      ::placeholder{
        color: ${props => props.theme.colors.grey03};
      }
    }


    > span {
      color: ${props => props.theme.colors.mainColor};
      font-size: 24px;
      font-weight: 600;
      text-align: ${props => (props.hasSufix ? 'left' : 'center')};
      width: ${props => (props.hasSufix ? '50%' : 'auto')};
      padding: 0 8px;
    }

  }

`


export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 12px;

  svg {
    margin: 0%;
    color: ${props => props.theme.colors.dange};
  }

  span {
    background: ${props => props.theme.colors.dange};
    color: #fff;
    font-weight: 600;

    &::before {
      border-color: ${props => props.theme.colors.dange} transparent;
    }
  }
`
